let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lRZLY")).then(() => parcelRequire('7CCUS'));